import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription, throwError } from 'rxjs';

import { DepositService, ToastService } from '../../core/services';
import { Deposit } from '../../core/models/deposit.model';
import { catchError, finalize } from 'rxjs/operators';

@Component({
    selector: 'gs-deposit-failed',
    templateUrl: './deposit-failed.component.html',
    standalone: false
})
export class DepositFailedComponent implements OnInit, OnDestroy {
  deposit: Deposit;

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private depositService: DepositService,
    private toastService: ToastService
  ) {
  }

  ngOnInit() {
    const depositId = this.route.snapshot.paramMap.get('id');
    if (!depositId) {
      this.router.navigate(['/error']);
      return;
    }

    this.getDeposit(depositId);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private getDeposit(depositId: string) {
    this.subscriptions.push(
      this.depositService.getDeposit(depositId)
        .pipe(
          catchError(e => {
            this.toastService.checkErrorForStatus(e);
            return throwError(e);
          }),
          finalize(() => { })
        )
        .subscribe((response: any) => {
          this.deposit = response;
        })
    );
  }
}
